import React from "react";

export default function ReasonItem({ icon, text }) {
  return (
    <div className="flex flex-col items-center mb-4 md:w-[30%] w-[90%]">
      <div className="text-4xl mb-2 text-primary">{icon}</div>
      <p className="text-center md:text-xl text-lg">{text}</p>
    </div>
  );
}
